// extracted by mini-css-extract-plugin
export default {"zoomModal":"k4-z"};